import { Component } from '@angular/core';
import { NgbTypeaheadSelectItemEvent } from '@ng-bootstrap/ng-bootstrap';
import AppSettings from 'src/app/common/app.settings';
import { SearchService } from 'src/app/components/search/search.service';
import { SearchFormTypes } from 'src/app/forms/forms.enum';
import { SelectorOption } from 'src/app/interfaces/form-and-field.interface';
import { SelectorOptionsService } from '../selector-options.service';
import { SuggestionSearchFieldShared } from '../suggestion-search-field.shared';

@Component({
  selector: 'app-multiple-search-form-field',
  templateUrl: './multiple-search-form-field.component.html',
  styleUrls: ['./multiple-search-form-field.component.scss'],
  providers: [SelectorOptionsService, SearchService],
})
export class MultipleSearchFormFieldComponent extends SuggestionSearchFieldShared {
  public selectedItems: SelectorOption[] = [];
  public SearchFormTypes: typeof SearchFormTypes = SearchFormTypes;

  public onSelectItem(event: NgbTypeaheadSelectItemEvent): void {
    event.preventDefault();

    this.selectedItems.push(event.item as SelectorOption);
    this.multipleSearchInput.nativeElement.value = '';
    this.fillControlValue();
  }

  public onCloseItem(item: SelectorOption): void {
    this.selectedItems.splice(this.selectedItems.indexOf(item), 1);
    this.multipleSearchInput.nativeElement.focus();
    this.fillControlValue();
  }

  public checkErrors(): void {
    this.formValidationService.checkMultipleSearchFieldValidationErrors(
      this.control,
      this.multipleSearchInput.nativeElement.value,
    );
  }

  protected getSelectedItems(): SelectorOption[] {
    return this.selectedItems;
  }

  protected onControlDisabled(): void {
    if (this.multipleSearchInput) {
      this.multipleSearchInput.nativeElement.value = '';
    }
  }

  protected override onNullControlValue(): void {
    this.selectedItems = [];
    super.onNullControlValue();
  }

  protected initSelectedItems(): void {
    const value = this.control.value as SelectorOption[];

    this.selectedItems = Array.isArray(value) ? value : [];
    this.fillControlValue();
    this.subscribeToControlChanges();
    this.optionsService.getUpdatedOptions(this.fieldAttribute, this.initialSearchParams, this.selectedItems);
  }

  private fillControlValue(): void {
    this.control.setValue(
      this.selectedItems
        .map((selectedItem: SelectorOption) => selectedItem.entity_id)
        .join(AppSettings.FORM_FIELD_ARRAY_VALUE_SEPARATOR),
    );
  }
}
